// Apollo does not return correct prototype to use it directly
import { PersonGridItemObject } from '@it2go/types';

export function personActiveAddress(person: PersonGridItemObject) {
    return person.addresses?.find((it) => {
        const actDate = new Date();
        const from = it.validFrom ? new Date(it.validFrom) : null;
        const to = it.validTo ? new Date(it.validTo) : null;

        return (!from || from < actDate) && (!to || to > actDate);
    })?.address || null;
}
